/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Stimme } from '../models/Stimme';
import type { StimmenImportListe } from '../models/StimmenImportListe';
import type { StimmenListe } from '../models/StimmenListe';
import type { StimmeUpdate } from '../models/StimmeUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class StimmenService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Liste der verfügbaren Stimmen
   * Gibt eine Liste aller verfügbaren Stimmen zurück
   * @returns StimmenListe Liste der Stimmen
   * @throws ApiError
   */
  public getStimmenListe(): CancelablePromise<StimmenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/stimmen',
      errors: {
        401: `Unauthorized for this request (getStimmenListe)`,
        403: `Forbidden for this request (getStimmenListe)`,
      },
    });
  }

  /**
   * Stimmen importieren
   * Importiert Stimmen von einem externen Service
   * @returns StimmenListe Die importierten Stimmen
   * @throws ApiError
   */
  public importStimmen({
    requestBody,
  }: {
    /**
     * Daten für den Stimmenimport
     */
    requestBody: StimmenImportListe,
  }): CancelablePromise<StimmenListe> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/stimmen/import',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized for this request (importStimmen)`,
        403: `Forbidden for this request (importStimmen)`,
      },
    });
  }

  /**
   * Details einer Stimme
   * Gibt die Details einer spezifischen Stimme zurück
   * @returns Stimme Details der Stimme
   * @throws ApiError
   */
  public getStimme({
    stimmeId,
  }: {
    /**
     * Eindeutige ID der Stimme
     */
    stimmeId: string,
  }): CancelablePromise<Stimme> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/stimmen/{stimmeId}',
      path: {
        'stimmeId': stimmeId,
      },
      errors: {
        401: `Unauthorized for this request (getStimmeDetails)`,
        403: `Forbidden for this request (getStimmeDetails)`,
        404: `Not Found for this request (getStimmeDetails)`,
      },
    });
  }

  /**
   * Stimme aktualisieren
   * Aktualisiert die Details einer spezifischen Stimme
   * @returns Stimme Aktualisierte Stimme
   * @throws ApiError
   */
  public updateStimme({
    stimmeId,
    requestBody,
  }: {
    /**
     * Eindeutige ID der Stimme
     */
    stimmeId: string,
    requestBody: StimmeUpdate,
  }): CancelablePromise<Stimme> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/v1/stimmen/{stimmeId}',
      path: {
        'stimmeId': stimmeId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request – invalid update data`,
        401: `Unauthorized for this request (updateStimme)`,
        403: `Forbidden for this request (updateStimme)`,
        404: `Not Found for this request (updateStimme)`,
      },
    });
  }

  /**
   * Stimme löschen
   * Löscht eine spezifische Stimme
   * @returns void
   * @throws ApiError
   */
  public deleteStimme({
    stimmeId,
  }: {
    /**
     * Eindeutige ID der Stimme
     */
    stimmeId: string,
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/stimmen/{stimmeId}',
      path: {
        'stimmeId': stimmeId,
      },
      errors: {
        401: `Unauthorized for this request (deleteStimme)`,
        403: `Forbidden for this request (deleteStimme)`,
        404: `Not Found for this request (deleteStimme)`,
      },
    });
  }

}
